import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/app/model/user';
import gravatarUrl from 'gravatar-url';

@Component({
  selector: 'aw-gravatar-picture',
  templateUrl: './gravatar-picture.component.html',
  styleUrls: ['./gravatar-picture.component.scss']
})
export class GravatarPictureComponent implements OnInit {

  @Input() imageType: "retro" | "robohash" | "mp" = "retro";
  @Input() user: User;
  @Input() size: number = 200;
  profilePictureSource: string = "";
  profilePictureAltText: string = "profile picture";

  constructor() { }

  ngOnInit(): void {
    const options = { rating: "g", size: this.size };
    if (this.user.email != undefined) this.profilePictureSource = gravatarUrl(this.user.email) + `?d=${this.imageType}&r=${options.rating}&s=${options.size}`;
    this.profilePictureAltText = `${this.user.firstName} ${this.user.lastName}'s profile picture`;
  }

}
